import {
  ListItemButton as MuiListItemButton,
  ListItemButtonProps as MuiListItemButtonProps,
} from '@mui/material';

export type ListItemButtonProps = MuiListItemButtonProps;

export const ListItemButton = MuiListItemButton;
